// Рейтинг репетитора в CRM — ЕДИНАЯ плашка «★ 4.9 · 12» (решение Антона 24.08:
// «везде, где фамилия репетитора»). Цифра — та же, что на сайте: платформа
// считает её одним блоком (lesson-rating/tutor-rating.ts), CRM только показывает.
// Карта рейтингов грузится ОДИН раз на страницу (/api/platform/ratings, кэш 5 мин
// на бэке CRM). Если у карточки уже есть rating/reviewCount (список «Запись на
// пробный») — берём их, карту не ждём.
import { useEffect, useState } from 'react'
import api from '../api'

let cache = null
let pending = null

export function useTeacherRatings() {
  const [map, setMap] = useState(cache)
  useEffect(() => {
    if (cache) { setMap(cache); return }
    if (!pending) {
      pending = api.get('/api/platform/ratings')
        .then(r => { cache = (r.data && r.data.ratings) || {}; return cache })
        .catch(() => ({}))
    }
    let alive = true
    pending.then(m => { if (alive) setMap(m) })
    return () => { alive = false }
  }, [])
  return map || {}
}

export default function TeacherRating({ mkId, rating, reviewCount, style }) {
  const map = useTeacherRatings()
  const r = rating != null ? { rating, reviewCount } : (mkId != null ? map[String(mkId)] : null)
  if (!r || r.rating == null) return null
  return (
    <span title={'Рейтинг платформы: ' + r.rating + (r.reviewCount ? ', отзывов ' + r.reviewCount : '')}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 3, marginLeft: 6, padding: '1px 6px', borderRadius: 999,
        background: '#FFFBEB', border: '1px solid #FDE68A', color: '#0F172A', fontSize: 12, fontWeight: 700, lineHeight: 1.3,
        whiteSpace: 'nowrap', verticalAlign: 'middle', ...(style || {}) }}>
      <span style={{ color: '#fbbf24' }}>★</span> {r.rating}
      {r.reviewCount ? <span style={{ fontWeight: 500, color: '#94A3B8', fontSize: 11 }}>· {r.reviewCount}</span> : null}
    </span>
  )
}
